module.exports = __webpack_public_path__ + "static/img/icon_accident.c62cc11d.svg";